import { GzDashboardDeleteViewDialogContentWebComponent } from './component/GzDashboardDeleteViewDialogContentWebComponent';

export { GzDashboardDeleteViewDialogContentWebComponent };
